import type { SlotItem } from '../types';
import EmptyHint from './EmptyHint';

interface SlotPickerProps {
  slots: SlotItem[];
  selected: SlotItem | null;
  onSelect: (s: SlotItem) => void;
  loading?: boolean;
}

function formatTime(iso: string): string {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  } catch {
    return iso;
  }
}

export default function SlotPicker({ slots, selected, onSelect, loading }: SlotPickerProps) {
  if (loading) {
    return (
      <div className="aw-slots-grid" aria-busy="true">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="aw-skeleton" style={{ height: 44 }} />
        ))}
      </div>
    );
  }
  if (!slots.length) {
    return <EmptyHint variant="slots" />;
  }
  return (
    <div className="aw-slots-grid" role="listbox" aria-label="Slot disponibili">
      {slots.map((slot) => {
        const sel = selected?.start === slot.start;
        return (
          <button
            key={slot.start}
            role="option"
            aria-selected={sel}
            disabled={!slot.available}
            className={`aw-slot ${sel ? 'aw-selected' : ''}`}
            onClick={() => onSelect(slot)}
            type="button"
          >
            {formatTime(slot.start)}
          </button>
        );
      })}
    </div>
  );
}
